import { ReactNode, createContext, useContext } from 'react';

type AppContextValue = {
  clientLogo: ReactNode;
  dGLogo?: ReactNode;
  getRouteFromPath: (pathname: string) => { title: string; path: string } | undefined;
};

const AppContext = createContext<AppContextValue | null>(null);

export const AppContextProvider = AppContext.Provider;

export const useAppContext = () => {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error('useAppContext must be used within AppContextProvider');
  }
  return ctx;
};
